/* eslint-disable react/prop-types */
import React, { useState } from "react";
import "./DeleteSlide.css";

//DB imports
import { db } from "../../firebaseConfig";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import ConfirmModal from "./modals/confirmModal";
import DeleteIcon from "@mui/icons-material/Delete";

function DeleteSlide({ viewId, slideId, onSlideDeleted }) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDeleteSlide = async () => {
    const docRef = doc(db, "views", viewId);
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        let existingSlides = docSnap.data().slides || [];
        let filteredSlides = existingSlides.filter((s) => {
          // console.log("componentToDelete", componentToDelete, component.id);
          return slideId !== s.id;
        });
        // console.log("existingSlides", existingSlides);
        // console.log("filteredSlides", filteredSlides);

        await updateDoc(docRef, {
          slides: filteredSlides,
        });

        console.log("Slide deleted successfully!");

        await onSlideDeleted();
      } else {
        console.error("Document does not exist.");
      }
    } catch (error) {
      console.error("Error deleting slide:", error);
    }

    setIsDeleteModalOpen(false);
  };

  return (
    <div className="delete-slide">
      <button
        className="delBtn"
        onClick={() => {
          setIsDeleteModalOpen(true);
        }}
      >
        <DeleteIcon />
      </button>
      <ConfirmModal isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} onConfirm={handleDeleteSlide} />
    </div>
  );
}

export default DeleteSlide;
